import React from 'react';
import { Link } from 'react-router-dom';

const OrderNowButton = ({
  link = '/order-food',
  label = 'Order Now',
  buttonClass = 'order-button order-now-btn',
  containerClass = 'order-button-container text-center mt-20 order-now-btn-container',
  linkClass = 'order-now-btn-link',
  disabled = false,
  icon,
}) => {
  return (
    <div className={containerClass}>
      {disabled ? (
        <div className={buttonClass} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.5, cursor: 'not-allowed' }}>
          {/* {icon && (
            <img src={icon} alt={label} style={{ height: 80, width: 80, marginBottom: 4, display: 'block' }} />
          )} */}
          <span style={{ display: 'block' }}>{label}</span>
          <span style={{ color: '#eb6c20', marginTop: 8, fontWeight: 500, fontSize: '1rem' }}>Timings 10am-7pm</span>
        </div>
      ) : (
        <Link to={link} className={linkClass}>
          <div className={buttonClass} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            {icon && (
              <img src={icon} alt={label} style={{ height: 80, width: 80, marginBottom: 4, display: 'block' }} />
            )}
            <span style={{ display: 'block' }}>{label}</span>
          </div>
        </Link>
      )}
    </div>
  );
};

export default OrderNowButton;
